export default __webpack_public_path__ + "static/media/sampleReport3.af381a19.png";